import {Rng} from '../../shared';
import {BIOMES,WEATHER} from '../../content/explore/world';
import type {Journey} from './index';
import {placeAt} from './expedition';
export interface StoryLine {key:string;params?:Record<string,string|number>}
/** The journal describes available or earned outcomes, never an expired offer. */
export function questRewardKey(j:Journey):string {
 const t=j.trek;
 if(t?.questProgress===2)return t.flags.includes('moth-freed')?'moth.earned':'questRewardEarned';
 return t?.quest==='lantern'?t.flags.includes('moth-debt')?'moth.already':'moth.offer':'questReward';
}
/** Authored fragments, selected from saved facts. No remote or pretend AI. */
export function expeditionStory(j:Journey):StoryLine[]{
 const t=j.trek;if(!t)return [];
 const p=placeAt(t.worldSeed,t.node,j.mode==='crypt');
 const variant=new Rng(`${t.worldSeed}:story:${t.node}:${t.encounter}`).int(0,2);
 const lines:StoryLine[]=[{key:t.encounter==='traveller'&&t.last?.key==='mothPaid'?'explore.voyage.moth.traveller':t.encounter==='quest'?`explore.voyage.quest.${t.quest}.${t.questProgress}`:`explore.voyage.scene.${t.encounter}.${variant}`},{key:`explore.voyage.setting.${BIOMES[p.biome]}`},{key:`explore.voyage.sky.${WEATHER[p.weather]}`}];
 if(j.supply<=2)lines.push({key:'explore.voyage.context.hungry',params:{n:j.supply}});
 else if(j.wounds>=3)lines.push({key:'explore.voyage.context.hurt',params:{n:Math.max(0,5-j.wounds)}});
 else if(t.trouble>0)lines.push({key:'explore.voyage.context.notorious',params:{n:t.trouble*4}});
 else if(t.flags.includes('companion'))lines.push({key:'explore.voyage.context.companion'});
 else if(t.flags.includes('map'))lines.push({key:'explore.voyage.context.map'});
 else if(t.favour>0)lines.push({key:'explore.voyage.context.favour',params:{n:t.favour*2}});
 return lines;
}
